import MythViewer from "../components/MythViewer";
import MythBuilder from "../types/MythBuilder";

const builder = new MythBuilder();

builder.myth("양자 컴퓨터는 고전 컴퓨터보다 빠르다")`
양자 컴퓨터가 일부 문제를 고전 컴퓨터보다 빠르게 해결할 수 있는 것은 사실입니다. 하지만 그것은 일부 문제에 한정된 이야기입니다. 양자 컴퓨터에서 효율적으로 사용할 수 있는 양자 알고리즘이 별도로 개발되지 않는 이상 양자 컴퓨터의 실행 시간은 고전 컴퓨터와 다르지 않을 것입니다.

지금까지 발견된 효율적인 양자 알고리즘은 그로버 알고리즘(비구조화된 데이터에서 탐색), 쇼어 알고리즘(소인수 분해) 등이 있으며 아직까지도 연구가 진행 중입니다.
`.myth("양자 컴퓨터는 현대 암호 체계를 모두 뚫어버릴 것이다")`
이는 일부 사실입니다. 만약 제대로된 양자 컴퓨터가 개발 된다면, 현대에 사용되는 많은 암호 체계는 무력화 될 것입니다.

현재 많이 사용되고 있는 암호 체계 중 하나가 RSA라는 암호 체계인데, RSA 암호화는 "큰 소수끼리 곱하는 것은 쉽지만 큰 수를 소인수 분해하는 것은 어렵다"라는 사실을 기반으로 정립되었습니다. 고전 컴퓨터로 암호 체계를 뚫기 위해서는 몇 천년이 넘는 시간이 걸리는 연산을 해야하기 때문에 고전 컴퓨터만 놓고 본다면 RSA는 충분히 안전한 암호 체계입니다.

그런데 양자 컴퓨터는 쇼어 알고리즘을 사용하면 소인수 분해를 고전 컴퓨터보다 훨씬 빠르고 효율적이게 할 수 있습니다. 이로 인해서 만약 제대로된 양자 컴퓨터가 개발된다면 RSA 암호 체계는 무용지물이 될 것입니다.

하지만 지금은 아직 걱정할 단계까지 온 것 같진 않습니다. 왜냐하면 '제대로된 양자 컴퓨터'가 나오지 않았기 때문입니다. 지금까지 개발된 범용 양자 컴퓨터는 50개 내외의 큐비트만을 다룰 수 있고, 암호 체계를 뚫기엔 역부족한 숫자입니다. 하지만 양자 컴퓨터의 개발에 대비하여 양자역학적으로 안전한 암호 체계를 만들어야한다는 요구는 갈수록 커지고 있습니다.
`.myth("양자 컴퓨터는 고전 컴퓨터를 대체할 것이다")`
미래는 아무도 모르지만, 매우 가능성이 낮은 시나리오입니다. 적어도 가까운 시일 내에는 절대 일어나지 않을 일입니다.

양자 컴퓨터는 아직 '상용화'를 바라보기엔 갈 길이 너무 많이 남아있습니다. 당장 연구 목적으로 사용하기에도 충분하지 않습니다. 상온에서는 큐비트가 안정적으로 유지되지 않을 뿐더러, 양자 오류라는 치명적인 결함 때문에 아직 해결해야 할 과제가 많습니다.

양자 컴퓨터가 안정화된다고 해도, 그 가격은 상상을 초월할 것이며 일반인이 굳이 집에 양자 컴퓨터를 들여놓을 일은 없을 것 입니다. 지금의 슈퍼 컴퓨터가 연구실이나 정부 기관 등에서만 사용되고 일반 가정에는 보급되지 않은 것처럼, 양자 컴퓨터도 꼭 필요한 곳에서만 연구용으로 사용될 가능성이 높습니다.
`;

export default function Myth2Page() {
  return <MythViewer chapter={3} index={2} myths={builder.build()} />;
}
